(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["perez-lead-tracking"] && !Shopify.designMode) return;
  try {
    (() => {
  const config = document.querySelector('[data-perez-analytics]');
  if (!config || config.dataset.themePreview === 'true' || new URLSearchParams(location.search).has('preview_theme_id')) return;
  const pendingKey = 'perez_contact_pending_v1';
  const pagePath = config.dataset.pagePath;
  const service = pagePath.includes('we-buy-gold-diamonds') ? 'gold_buying' : pagePath.includes('contact-us') ? 'custom_jewelry' : 'store_support';
  const allowed = () => window.Shopify?.customerPrivacy?.analyticsProcessingAllowed?.() === true;
  const send = (name, parameters) => {
    if (!allowed() || typeof window.gtag !== 'function') return false;
    window.gtag('event', name, {...parameters, send_to: config.dataset.measurementId, page_location: config.dataset.storeOrigin + pagePath, page_referrer: ''});
    return true;
  };
  const success = () => {
    if (!allowed() || !document.querySelector('[data-perez-lead-success]')) return;
    try {
      const pending = JSON.parse(sessionStorage.getItem(pendingKey) || 'null');
      if (!pending || pending.path !== pagePath || Date.now() - pending.time > 1800000) return;
      if (send('generate_lead', {lead_source: 'website_contact_form', service_type: pending.service, form_id: 'ContactForm'})) sessionStorage.removeItem(pendingKey);
    } catch {}
  };
  document.addEventListener('submit', event => {
    if (!(event.target instanceof HTMLFormElement) || event.target.id !== 'ContactForm' || !event.target.checkValidity() || !allowed()) return;
    try { sessionStorage.setItem(pendingKey, JSON.stringify({path: pagePath, service, time: Date.now()})); } catch {}
  });
  document.addEventListener('click', event => {
    const link = event.target instanceof Element ? event.target.closest('a[href]') : null;
    if (!link) return;
    const href = link.getAttribute('href') || '';
    if (href.startsWith('tel:') || href.startsWith('mailto:')) send('contact_click', {contact_method: href.startsWith('tel:') ? 'phone' : 'email', service_type: service});
  });
  document.addEventListener('visitorConsentCollected', () => {
    if (!allowed()) { try { sessionStorage.removeItem(pendingKey); } catch {} }
    else success();
  });
  if (window.Shopify?.customerPrivacy) success();
  else if (typeof window.Shopify?.loadFeatures === 'function') window.Shopify.loadFeatures([{name: 'consent-tracking-api', version: '0.1'}], error => { if (!error) success(); });
})();
  } catch(e) { console.error(e); }
})();

})();
